import { config } from '@uhg-abyss/web/tools/config';
import { http } from '../../tools/http';
import { getFeature } from '../../tools/features';

export const postPdf = async (payload) => {
  let url = `${config('ZUUL_ATTACHMENT_CORE_API_URL')}/api/pln/attachment/v1.0`;

  if (getFeature('US4545128_ELIGIBILITY_STARGATE_ALINK_MIGRATION')) {
    url = `${config('ELINK_ATTACHMENT_CORE_API_URL')}/document-submissions/v1`;
  }

  const formData = new FormData();
  formData.append('referenceId', payload.referenceId);
  formData.append('attachmentType', payload.attachmentType);
  formData.append('files', payload.files);
  const response = await http({
    id: 'get-attachment-api',
    method: 'POST',
    withCredentials: true,
    cache: false,
    retry: false,
    url,
    formData: {
      referenceId: payload.referenceId,
      attachmentType: payload.attachmentType,
      files: payload.files,
    },
  });
  if (!response.data || response.data.serviceCallStatus === 'failure') {
    throw response.data;
  }
  return response.data;
};
